export default __webpack_public_path__ + "static/media/included-check.cecbfb65.svg";